export default __webpack_public_path__ + "static/media/folder-file-storage.627b9974.svg";